import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * PointsPerEntityApi - axios parameter creator
 * @export
 */
const PointsPerEntityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/PointsPerEntity/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/PointsPerEntity/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Saves an event\'s points, active dates and description; its code, type and name are fixed. Active from is required (without it the event never applies), points are 0 or more (only a new appointment may cost points), and the event cannot end before it starts. It used to copy the whole token onto the row, code and name included, and to turn a reversed date range into a 500. (Auth roles: System)
         * @param {LoyaltyPointEventTypeToken} [LoyaltyPointEventTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (LoyaltyPointEventTypeToken, options = {}) => {
            const localVarPath = `/v1/PointsPerEntity/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(LoyaltyPointEventTypeToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PointsPerEntityApi - functional programming interface
 * @export
 */
const PointsPerEntityApiFp = function (configuration) {
    const localVarAxiosParamCreator = PointsPerEntityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointsPerEntityApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointsPerEntityApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Saves an event\'s points, active dates and description; its code, type and name are fixed. Active from is required (without it the event never applies), points are 0 or more (only a new appointment may cost points), and the event cannot end before it starts. It used to copy the whole token onto the row, code and name included, and to turn a reversed date range into a 500. (Auth roles: System)
         * @param {LoyaltyPointEventTypeToken} [LoyaltyPointEventTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(LoyaltyPointEventTypeToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(LoyaltyPointEventTypeToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointsPerEntityApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PointsPerEntityApi - factory interface
 * @export
 */
const PointsPerEntityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PointsPerEntityApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Saves an event\'s points, active dates and description; its code, type and name are fixed. Active from is required (without it the event never applies), points are 0 or more (only a new appointment may cost points), and the event cannot end before it starts. It used to copy the whole token onto the row, code and name included, and to turn a reversed date range into a 500. (Auth roles: System)
         * @param {LoyaltyPointEventTypeToken} [LoyaltyPointEventTypeToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(LoyaltyPointEventTypeToken, options) {
            return localVarFp.update(LoyaltyPointEventTypeToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PointsPerEntityApi - object-oriented interface
 * @export
 * @class PointsPerEntityApi
 * @extends {BaseAPI}
 */
class PointsPerEntityApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsPerEntityApi
     */
    getAll(options) {
        return PointsPerEntityApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsPerEntityApi
     */
    getById(id, options) {
        return PointsPerEntityApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Saves an event\'s points, active dates and description; its code, type and name are fixed. Active from is required (without it the event never applies), points are 0 or more (only a new appointment may cost points), and the event cannot end before it starts. It used to copy the whole token onto the row, code and name included, and to turn a reversed date range into a 500. (Auth roles: System)
     * @param {LoyaltyPointEventTypeToken} [LoyaltyPointEventTypeToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PointsPerEntityApi
     */
    update(LoyaltyPointEventTypeToken, options) {
        return PointsPerEntityApiFp(this.configuration).update(LoyaltyPointEventTypeToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { PointsPerEntityApi, PointsPerEntityApiAxiosParamCreator, PointsPerEntityApiFactory, PointsPerEntityApiFp };
//# sourceMappingURL=points-per-entity-api.js.map
